import { applyTheme } from "@amzn/awsui-components-react/polaris/theming";

const ONE_THEME_CLASS = "awsui-one-theme";
const ONE_THEME_STORAGE_KEY = "oneTheme";

export function isOneThemeEnabled(): boolean {
  const storedPreference = window.localStorage.getItem(ONE_THEME_STORAGE_KEY);
  return storedPreference === null || storedPreference === "true";
}

export function setOneThemeEnabled(enabled: boolean): void {
  const alreadyActive = enabled === isOneThemeEnabled();
  window.localStorage.setItem(ONE_THEME_STORAGE_KEY, String(enabled));
  if (alreadyActive) {
    return;
  }
  window.location.reload();
}

function applyDarkSurfaceOverrides() {
  return applyTheme({
    baseThemeId: "one-theme",
    theme: {
      tokens: {
        colorBackgroundLayoutMain: { light: "#fcfcfc", dark: "#1a1a1a" },
        colorBackgroundContainerContent: { light: "#ffffff", dark: "#222222" },
        colorBackgroundContainerHeader: { light: "#ffffff", dark: "#222222" },
        colorBackgroundCard: { light: "#ffffff", dark: "#222222" },
        colorBackgroundInputDefault: { light: "#ffffff", dark: "#222222" },
        colorBackgroundCellShaded: { light: "#f8f8f8", dark: "#2a2a2a" },
        colorBorderDividerDefault: { light: "#e1e1e1", dark: "#666666" },
        colorBorderDividerSecondary: { light: "#ededed", dark: "#4d4d4d" },
      },
    },
  });
}

export function applyLuscaTheme(): void {
  if (!isOneThemeEnabled()) {
    document.body.classList.add("awsui-visual-refresh");
    return;
  }

  document.body.classList.add(ONE_THEME_CLASS);
  applyDarkSurfaceOverrides();
}
